__turbopack_context__.v({
  "cardBox": "_7L11Hq_cardBox",
});
